var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.albumEditRoute}},[_c('div',{staticClass:"embed-responsive embed-responsive-1by1"},[_c('img',{staticClass:"embed-responsive-item",attrs:{"src":_vm.album.avatar}})]),_c('span',[_vm._v(_vm._s(_vm.album.titulo)+" "),(_vm.album.ano)?_c('span',[_vm._v("- "+_vm._s(_vm.album.ano))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }